import FirebaseKey from "../../components/FirebaseKey/FirebaseKey";
import PageLayout from "../../components/Layout/PageLayout";
import FirebaseService from "../../core/services/firebase.service";

const Agreement = () => {
  return (
    <PageLayout>
      <div className="pb-1">
        <h2 className="text-[32px] font-medium text-black text-start">
          <FirebaseKey
            firebaseKey={FirebaseService.terms_and_conditions_popup_header}
          />
        </h2>
      </div>
      <div className="mx-auto w-full">
        <div className="">
          <div className="text-[rgba(67,66,66,0.60)] text-base font-medium text-start">
            <FirebaseKey
              firebaseKey={FirebaseService.terms_and_conditions_popup_text}
            />
          </div>
        </div>
      </div>
    </PageLayout>
  );
};

export default Agreement;
